import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import PCContainer from "../../components/atoms/layout/pcContainer";

import useDisplay from "../../hooks/useDisplay";

import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import MainBtn from "../../components/atoms/button/mainBtn";
import LSRgDisplay02 from "../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgH2HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSBdH2HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import LSBdDisplay01 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay01";
import Pagination from "../../components/molecules/pagination";
import Empty from "../../components/molecules/empty";
import ReviewItemPage from "../../components/organisms/lecture/reviewItemPage";

import { route } from "../../router/route";
import LectureApi from "../../api/lecture.api";
import { errorHandler } from "../../util/errorHandler";

import DetailTop from "../../components/templates/lecture/detailTop";
import { fileUrl } from "../../api/api";
import TermApi from "../../api/term.api";
import ReviewApi from "../../api/review.api";
import { toast } from "react-toastify";
import moment from "moment";
import PaymentApi from "../../api/payment.api";
import Loading from "../../components/templates/loading";

const LectureDetail = () => {
  const { id } = useParams();

  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const navigate = useNavigate();
  const location = useLocation();
  const { isReviewIn } = location.state || {};

  const section1Ref = useRef(null);
  const section2Ref = useRef(null);
  const section3Ref = useRef(null);
  const section4Ref = useRef(null);

  const [reviewList, setReviewList] = useState([]);

  const [tabValue, setTabValue] = useState("강의 소개");

  const [contentReivewList, setcontentReivewList] = useState([]);

  const [page, setPage] = useState(1); //해당 부분 페이지네이션 처리안함
  const [pagination, setPagination] = useState({
    size: 6, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  const [isMobileBottomBtn, setIsMobileBottomBtn] = useState(false);
  const [isScrap, setIsScrap] = useState(false);
  const [isScrapProcessing, setIsScrapProcessing] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isLectureLoading, setIsLectureLoading] = useState(true);

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (isReviewIn && section4Ref) {
      setTimeout(() => {
        scrollToSection(section4Ref);
      }, 200);
    }
  }, [location, section4Ref]); // eslint-disable-line react-hooks/exhaustive-deps

  const scrollToSection = (ref) => {
    const offset = isSmall ? -50 : -30; // 조정할 스크롤 값
    if (ref.current) {
      const elementPosition = ref.current.getBoundingClientRect().top;
      window.scrollBy({
        top: elementPosition + offset,
        behavior: "smooth",
      });
    }
  };

  const handleScroll = () => {
    if (window.scrollY > 900) {
      setIsMobileBottomBtn(true);
    } else {
      setIsMobileBottomBtn(false);
    }

    if (section1Ref.current) {
      const rect = section1Ref.current.getBoundingClientRect();
      if (rect.top >= 0 && rect.top <= window.innerHeight * 0.5) {
        setTabValue("강의 소개");
      }
    }

    if (section2Ref.current) {
      const rect = section2Ref.current.getBoundingClientRect();
      if (
        rect.top >= window.innerHeight * 0.1 &&
        rect.top <= window.innerHeight * 0.7
      ) {
        setTabValue("커리큘럼");
      }
    }

    if (section3Ref.current) {
      const rect = section3Ref.current.getBoundingClientRect();
      if (
        rect.top >= window.innerHeight * 0.1 &&
        rect.top <= window.innerHeight * 0.7
      ) {
        setTabValue("강사소개");
      }
    }

    if (section4Ref.current) {
      const rect = section4Ref.current.getBoundingClientRect();
      if (
        rect.top >= window.innerHeight * 0.1 &&
        rect.top <= window.innerHeight * 0.7
      ) {
        setTabValue("후기");
      }
    }
  };

  // Utility function for debouncing
  const debounce = (func, wait) => {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  useEffect(() => {
    const debouncedHandleScroll = debounce(handleScroll, 100); // 100ms debounce time

    window.addEventListener("scroll", debouncedHandleScroll);

    // Initial check for the first time page loads
    handleScroll();

    return () => {
      window.removeEventListener("scroll", debouncedHandleScroll);
    };
  }, []);

  const [lectureInfo, setLectureInfo] = useState(null);
  const [learningTermInfo, setLearningTermInfo] = useState();
  const [refundTermInfo, setRefundTermInfo] = useState();
  const [curriculumList, setCurriculumList] = useState([]);

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (!/^\d+$/.test(id) || Number(id) < 1) {
      toast("올바르지 않은 강의입니다.");
      navigate(route.lecture_list, { replace: true });
      return;
    }

    getLectureInfo();
    getLearningTermInfo();
    getRefundTermInfo();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getLectureInfo = async () => {
    try {
      const response = (await LectureApi.getDetail(id)).data.data.content;

      setLectureInfo(response);
      setIsScrap(response.isScrap);
    } catch (error) {
      errorHandler(error);
      navigate(route.lecture_list, { replace: true });
    } finally {
      setIsLectureLoading(false);
    }
  };

  const getLearningTermInfo = async () => {
    try {
      const response = (await TermApi.getDetail(6)).data.data.content;
      setLearningTermInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getRefundTermInfo = async () => {
    try {
      const response = (await TermApi.getDetail(5)).data.data.content;
      setRefundTermInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (lectureInfo?.id) {
      getCurriculumList();
      getTopReviewList();
    }
  }, [lectureInfo]); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (lectureInfo?.id) {
      getReviewList();
      if (page > 1) scrollToSection(section4Ref);
    }
  }, [page, lectureInfo?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const getCurriculumList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        orderBy: "ASC",
        lectureVideoId: lectureInfo.id,
      };

      const response = (await LectureApi.getCurriculumList(data)).data.data
        .content;
      setCurriculumList(response ?? []);
    } catch (error) {
      errorHandler(error);
    }
  };

  const scrapFunc = async () => {
    if (isScrapProcessing || !lectureInfo?.id) return;

    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("스크랩하려면 로그인을 해주세요.");
      navigate(route.login, { state: { path: window.location.href } });
      return;
    }

    try {
      setIsScrapProcessing(true);
      const requestData = {
        lectureVideoId: lectureInfo.id,
      };

      await LectureApi.putScrap(requestData);

      setIsScrap((current) => !current);
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsScrapProcessing(false);
    }
  };

  const getTopReviewList = async () => {
    try {
      const data01 = {
        page: 1,
        size: 5,
        lectureType: "Video",
        lectureVideoId: lectureInfo.id,
      };

      const response01 = (await ReviewApi.getList(data01)).data.data.content;
      setReviewList(response01 ?? []);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getReviewList = async () => {
    try {
      const data = {
        page: page,
        size: pagination.size,
        lectureType: "Video",
        lectureVideoId: lectureInfo.id,
      };

      const response = (await ReviewApi.getList(data)).data.data;

      setcontentReivewList(response.content ?? []);
      setPagination((current) => ({
        ...current,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / pagination.size),
      }));
    } catch (error) {
      errorHandler(error);
    }
  };

  function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds,
    ).padStart(2, "0")}`;
  }

  const lectureCheckFunc = async () => {
    if (isProcessing || !lectureInfo?.id) return;

    setIsProcessing(true);
    try {
      const data = {
        lectureVideoId: lectureInfo.id,
      };

      const response = (await LectureApi.lectureCheck(data)).data.data;

      if (response.existFlag) {
        toast("이미 구매한 수강권입니다.");
      } else {
        if (
          lectureInfo?.price === 0 ||
          sessionStorage.getItem("membership") === "true"
        ) {
          await onClickPayment();
        } else {
          navigate(`${route.lecture_payment}/${lectureInfo?.id}`);
        }
      }
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsProcessing(false);
    }
  };

  const onClickPayment = async () => {
    try {
      let paymentId = `${moment().format("YYMMDDHHmmss")}${Math.random()
        .toString(36)
        .slice(7)}`;

      const localData = {
        lectureVideoId: lectureInfo.id,
        paymentFlag:
          sessionStorage.getItem("membership") === "true" ? false : true,
        couponPay: 0,
        totalPay: lectureInfo.price,
        realPay: 0,
        payMethod: "FREE",
        pgPaymentId: paymentId,
      };

      await PaymentApi.paymentCheck(localData);

      await onPaymentFunc(paymentId);
    } catch (err) {
      errorHandler(err);
    }
  };

  const onPaymentFunc = async (paymentId) => {
    try {
      const localData = {
        lectureVideoId: lectureInfo.id,
        paymentFlag:
          sessionStorage.getItem("membership") === "true" ? false : true,
        couponPay: 0,
        totalPay: lectureInfo.price,
        realPay: 0,
        payMethod: "FREE",
        pgPaymentId: paymentId,
        orderNumber: paymentId,
      };

      await PaymentApi.payment(localData);

      navigate(route.lecture_payment_complete, {
        state: {
          lectureInfo: lectureInfo,
          localData: {
            ...localData,
            date: moment().format("YYYY.MM.DD HH:mm:ss"),
          },
        },
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  if (isLectureLoading) return <Loading />;

  return (
    <>
      <LectureDetailSection>
        <DetailTop
          lectureCheckFunc={lectureCheckFunc}
          isProcessing={isProcessing}
          lectureInfo={lectureInfo}
          reviewList={reviewList}
          setIsLoginCheckModal={() => {
            toast("수강하려면 로그인을 해주세요.");
            navigate(`${route.login}`, {
              state: { path: window.location.href },
            });
          }}
          scrapFunc={scrapFunc}
          isScrap={isScrap}
          isScrapProcessing={isScrapProcessing}
          reviewClicked={() => {
            scrollToSection(section4Ref);
          }}
        />

        <PCContainer
          style={{
            flexDirection: "column",
            padding: isSmall ? "10px 0px 80px 0px" : "20px 0px 90px 0px",
            width: "100%",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "sticky",
              zIndex: 20,
              top: 0,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              height: isSmall ? 45 : 60,
              background: "#fff",
            }}
          >
            <TabContain
              $isSmall={isSmall}
              $value={tabValue === "강의 소개"}
              onClick={() => {
                scrollToSection(section1Ref);
                setTabValue("강의 소개");
              }}
            >
              <LSRgH2HeadLine
                style={{
                  color: tabValue === "강의 소개" ? "#000000" : "#898E99",
                  textAlign: "center",
                  fontSize: isSmall ? 13 : 18,
                  lineHeight: isSmall ? "15.6px" : "25.2px",
                  fontWeight: isSmall ? 700 : 400,
                }}
              >
                강의 소개
              </LSRgH2HeadLine>
            </TabContain>
            <TabContain
              $isSmall={isSmall}
              $value={tabValue === "커리큘럼"}
              onClick={() => {
                scrollToSection(section2Ref);
                setTabValue("커리큘럼");
              }}
            >
              <LSRgH2HeadLine
                style={{
                  color: tabValue === "커리큘럼" ? "#000000" : "#898E99",
                  textAlign: "center",
                  fontSize: isSmall ? 13 : 18,
                  lineHeight: isSmall ? "15.6px" : "25.2px",
                  fontWeight: isSmall ? 700 : 400,
                }}
              >
                커리큘럼
              </LSRgH2HeadLine>
            </TabContain>
            <TabContain
              $isSmall={isSmall}
              $value={tabValue === "강사소개"}
              onClick={() => {
                scrollToSection(section3Ref);
                setTabValue("강사소개");
              }}
            >
              <LSRgH2HeadLine
                style={{
                  color: tabValue === "강사소개" ? "#000000" : "#898E99",
                  textAlign: "center",
                  fontSize: isSmall ? 13 : 18,
                  lineHeight: isSmall ? "15.6px" : "25.2px",
                  fontWeight: isSmall ? 700 : 400,
                }}
              >
                강사소개
              </LSRgH2HeadLine>
            </TabContain>
            <TabContain
              $isSmall={isSmall}
              $value={tabValue === "후기"}
              onClick={() => {
                scrollToSection(section4Ref);
                setTabValue("후기");
              }}
            >
              <LSRgH2HeadLine
                style={{
                  color: tabValue === "후기" ? "#000000" : "#898E99",
                  textAlign: "center",
                  fontSize: isSmall ? 13 : 18,
                  lineHeight: isSmall ? "15.6px" : "25.2px",
                  fontWeight: isSmall ? 700 : 400,
                }}
              >
                후기&nbsp;&nbsp;
              </LSRgH2HeadLine>
              <LSRgH2HeadLine
                style={{
                  color: "#5050FF",
                  fontSize: isSmall ? 13 : 18,
                  lineHeight: isSmall ? "15.6px" : "25.2px",
                  fontWeight: isSmall ? 700 : 400,
                }}
              >
                {lectureInfo?.reviewCount}
              </LSRgH2HeadLine>
            </TabContain>
          </div>

          <div
            ref={section1Ref}
            style={{
              padding: isSmall ? "20px 20px 60px 20px" : "60px 0px",
            }}
          >
            <div
              className="ql-editor"
              dangerouslySetInnerHTML={{
                __html: lectureInfo?.content,
              }}
            />
          </div>

          <div
            ref={section2Ref}
            style={{
              padding: isSmall ? "0px 20px 60px 20px" : "60px 0px",
            }}
          >
            <LSBdDisplay02
              style={{
                color: "#898E99",
                fontSize: isSmall ? 15 : 24,
                lineHeight: isSmall ? "21px" : "33.6px",
              }}
            >
              커리큘럼
            </LSBdDisplay02>

            <div
              style={{
                width: "100%",
                height: 1,
                background: "#DBDDE0",
                marginTop: 16,
                marginBottom: isSmall ? 16 : 40,
              }}
            />

            {curriculumList.map((item, index) => {
              return (
                <div
                  key={item.id}
                  style={{
                    padding: isSmall ? "16px 0px" : "30px 0px",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <LSBdDisplay02
                    style={{
                      color: "#101113",
                      textAlign: "center",
                      width: isSmall ? 69 : 175,
                      marginRight: isSmall ? 20 : 30,
                      fontSize: isSmall ? 16 : 24,
                      lineHeight: isSmall ? "22.4px" : "33.6px",
                    }}
                  >
                    0{index + 1}강
                  </LSBdDisplay02>
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <LSBdDisplay01
                      style={{
                        color: "#000000",
                        marginBottom: 8,
                        fontSize: isSmall ? 16 : 20,
                        lineHeight: isSmall ? "22.4px" : "28px",
                      }}
                    >
                      {item.title}
                    </LSBdDisplay01>
                    <LSRgH1HeadLine
                      style={{
                        color: "#000000",
                        fontSize: isSmall ? 12 : 16,
                        lineHeight: isSmall ? "14.4px" : "22.4px",
                      }}
                    >
                      {item.content}
                    </LSRgH1HeadLine>
                  </div>
                  <LSBdH2HeadLine
                    style={{
                      color: "#000000",
                      fontSize: isSmall ? 12 : 18,
                      lineHeight: isSmall ? "14.4px" : "25.2px",
                      marginRight: isSmall ? 17 : 0,
                      marginLeft: isSmall ? 30 : 0,
                    }}
                  >
                    {formatTime(item.playTime)}
                  </LSBdH2HeadLine>
                </div>
              );
            })}
          </div>
          <div
            ref={section3Ref}
            style={{
              padding: isSmall ? "0px 20px 60px 20px" : "60px 0px",
            }}
          >
            <LSBdDisplay02
              style={{
                color: "#898E99",
                fontSize: isSmall ? 15 : 24,
                lineHeight: isSmall ? "21px" : "33.6px",
              }}
            >
              강사 소개
            </LSBdDisplay02>

            <div
              style={{
                width: "100%",
                height: 1,
                background: "#DBDDE0",
                marginTop: 16,
                marginBottom: isSmall ? 16 : 40,
              }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: isSmall ? "column" : "row",
                marginLeft: isSmall ? 0 : 40,
              }}
            >
              {isSmall ? null : (
                <img
                  src={
                    lectureInfo?.instructorServerFileName
                      ? `${fileUrl}/${lectureInfo?.instructorServerFileName}`
                      : ""
                  }
                  style={{
                    borderRadius: 999,
                    width: isSmall ? 158 : 300,
                    height: isSmall ? 158 : 300,
                    marginRight: isSmall ? 20 : 70,
                  }}
                  alt="column"
                />
              )}

              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  marginTop: isSmall ? 10 : 0,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: isSmall ? "row" : "column",
                  }}
                >
                  {isSmall ? (
                    <img
                      src={
                        lectureInfo?.instructorServerFileName
                          ? `${fileUrl}/${lectureInfo.instructorServerFileName}`
                          : "/assets/icons/profile.png"
                      }
                      style={{
                        borderRadius: 999,
                        width: isSmall ? 158 : 300,
                        height: isSmall ? 158 : 300,
                        marginRight: isSmall ? 20 : 70,
                      }}
                      alt="column"
                    />
                  ) : null}

                  <div
                    style={{
                      flex: 1,
                    }}
                  >
                    <LSRgH1HeadLine
                      style={{
                        marginBottom: isSmall ? 4 : 8,
                        color: "#000000",
                        fontSize: isSmall ? 12 : 16,
                        lineHeight: isSmall ? "14.4px" : "22.4px",
                      }}
                    >
                      강사명
                    </LSRgH1HeadLine>
                    <LSBdDisplay02
                      style={{
                        marginBottom: isSmall ? 8 : 30,
                        color: "#000000",
                        fontSize: isSmall ? 16 : 24,
                        lineHeight: isSmall ? "22.4px" : "33.6px",
                      }}
                    >
                      {lectureInfo?.instructorName}
                    </LSBdDisplay02>
                    <div
                      style={{
                        background: "#F6F6FF",
                        borderRadius: 15,
                        padding: isSmall ? "20px" : "30px 20px",
                      }}
                    >
                      <img
                        alt="mark"
                        src="/assets/icons/mark.svg"
                        style={{
                          width: isSmall ? 8 : "auto",
                          height: isSmall ? 6 : "auto",
                        }}
                      />
                      <LSRgH1HeadLine
                        style={{
                          color: "#000000",
                          marginTop: 10,
                          fontSize: isSmall ? 12 : 16,
                          lineHeight: isSmall ? "14.4px" : "22.4px",
                        }}
                      >
                        {lectureInfo?.instructorIntro}
                      </LSRgH1HeadLine>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    width: "100%",
                    height: 1,
                    background: "#DBDDE0",
                    marginTop: isSmall ? 16 : 50,
                    marginBottom: isSmall ? 16 : 50,
                  }}
                />

                <LSBdH2HeadLine
                  style={{
                    color: "#000000",
                    marginBottom: 10,
                    fontSize: isSmall ? 12 : 18,
                    lineHeight: isSmall ? "14.4px" : "25.2px",
                  }}
                >
                  경력사항
                </LSBdH2HeadLine>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "4px",
                  }}
                >
                  {lectureInfo?.career
                    ? lectureInfo?.career.map((item, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              width: "46%",
                            }}
                          >
                            <LSRgH1HeadLine
                              style={{
                                color: "#000",
                                fontSize: isSmall ? 10 : 16,
                                lineHeight: isSmall ? "12px" : "22.4px",
                              }}
                            >
                              ・
                            </LSRgH1HeadLine>
                            <LSRgH1HeadLine
                              key={index}
                              style={{
                                color: "#000",
                                fontSize: isSmall ? 10 : 16,
                                lineHeight: isSmall ? "12px" : "22.4px",
                              }}
                            >
                              {item}
                            </LSRgH1HeadLine>
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
          </div>

          <div
            ref={section4Ref}
            style={{
              padding: isSmall ? "0px 20px 60px 20px" : "60px 0px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <LSBdDisplay02
                style={{
                  color: "#898E99",
                  fontSize: isSmall ? 15 : 24,
                  lineHeight: isSmall ? "21px" : "33.6px",
                }}
              >
                후기&nbsp;
              </LSBdDisplay02>
              <LSBdDisplay02
                style={{
                  color: "#5050FF",
                  fontSize: isSmall ? 15 : 24,
                  lineHeight: isSmall ? "21px" : "33.6px",
                }}
              >
                {lectureInfo?.reviewCount}
              </LSBdDisplay02>
            </div>
            <div
              style={{
                width: "100%",
                height: 1,
                background: "#DBDDE0",
                marginTop: 16,
                marginBottom: isSmall ? 16 : 40,
              }}
            />

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: isMobile ? "16px 20px" : "30px",
                  flexDirection: "row",
                  justifyContent: isSmall ? "space-between" : "flex-start",
                  flexWrap: "wrap",
                  width: "100%",
                }}
              >
                {contentReivewList.length > 0 ? (
                  contentReivewList.map((item, index) => {
                    return <ReviewItemPage key={item.id} data={item} />;
                  })
                ) : (
                  <Empty title={"후기가 없습니다."} />
                )}
              </div>
            </div>

            {contentReivewList.length > 0 ? (
              <Pagination
                currentPage={Number(page)}
                totalPages={pagination.totalPages}
                rangeSize={pagination.rangeSize}
                setPage={setPage}
              />
            ) : null}
          </div>

          <div
            style={{
              padding: isSmall ? "0px 20px 60px 20px" : "60px 0px",
            }}
          >
            <LSBdDisplay02
              style={{
                color: "#898E99",
                fontSize: isSmall ? 15 : 24,
                lineHeight: isSmall ? "21px" : "33.6px",
              }}
            >
              학습규정
            </LSBdDisplay02>

            <div
              style={{
                width: "100%",
                height: 1,
                background: "#DBDDE0",
                marginTop: 16,
                marginBottom: isSmall ? 16 : 40,
              }}
            />

            <LSRgH1HeadLine
              className="ql-editor"
              style={{
                color: "#000000",
                fontSize: isSmall ? 10 : 16,
                lineHeight: isSmall ? "12px" : "22.4px",
              }}
              dangerouslySetInnerHTML={{
                __html: learningTermInfo?.content,
              }}
            />
          </div>

          <div
            style={{
              padding: isSmall ? "0px 20px 0px 20px" : "40px 0px",
            }}
          >
            <LSBdDisplay02
              style={{
                color: "#898E99",
                fontSize: isSmall ? 15 : 24,
                lineHeight: isSmall ? "21px" : "33.6px",
              }}
            >
              환불규정
            </LSBdDisplay02>

            <div
              style={{
                width: "100%",
                height: 1,
                background: "#DBDDE0",
                marginTop: 16,
                marginBottom: isSmall ? 16 : 40,
              }}
            />

            <LSRgH1HeadLine
              className="ql-editor"
              style={{
                color: "#000000",
                fontSize: isSmall ? 10 : 16,
                lineHeight: isSmall ? "12px" : "22.4px",
              }}
              dangerouslySetInnerHTML={{
                __html: refundTermInfo?.content,
              }}
            />
          </div>
        </PCContainer>

        {isSmall && isMobileBottomBtn ? (
          <div
            style={{
              position: "fixed",
              bottom: 0,
              width: "100%",
              background: "#fff",
              padding: "20px",
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              zIndex: 999,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <div
                aria-disabled={isScrapProcessing}
                onClick={() => {
                  if (sessionStorage.getItem("isLogin") === "true") {
                    scrapFunc();
                  } else {
                    toast("스크랩하려면 로그인을 해주세요.");
                    navigate(`${route.login}`, {
                      state: { path: window.location.href },
                    });
                  }
                }}
                style={{
                  minWidth: isSmall ? 42 : 73,
                  height: isSmall ? 46 : 60,
                  border: "1px solid #DBDDE0",
                  background: "#fff",
                  cursor: "pointer",
                  borderRadius: 15,
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <img
                  src={
                    isScrap
                      ? "/assets/icons/bookmark_a.png"
                      : "/assets/icons/bookmark_d.png"
                  }
                  style={{
                    height: isSmall ? 20 : 32,
                    width: isSmall ? 20 : 32,
                  }}
                  alt="bookmark_d"
                />
              </div>

              <MainBtn
                disabled={isProcessing}
                onClick={() => {
                  if (sessionStorage.getItem("isLogin") === "true") {
                    lectureCheckFunc();
                  } else {
                    toast("수강하려면 로그인을 해주세요.");
                    navigate(`${route.login}`, {
                      state: { path: window.location.href },
                    });
                  }
                }}
                style={{
                  marginLeft: isSmall ? 16 : 29,
                  height: isSmall ? 46 : 60,
                }}
              >
                <LSRgDisplay02
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    fontSize: isSmall ? 16 : 24,
                    lineHeight: isSmall ? "22.4px" : "33.6px",
                  }}
                >
                  {isProcessing ? "처리 중..." : "수강하기"}
                </LSRgDisplay02>
              </MainBtn>
            </div>
          </div>
        ) : null}
      </LectureDetailSection>
    </>
  );
};

export default LectureDetail;

const LectureDetailSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const TabContain = styled.div`
  flex: 1 1 0%;
  height: ${(props) => (props.$isSmall ? "45px" : "60px")};
  border-bottom: ${(props) =>
    props.$value ? "2px solid rgb(80, 80, 255)" : "none"};

  justify-content: center;
  align-items: center;
  display: flex;

  cursor: pointer;
`;
